import { NavLink, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import { cn } from '@/lib/utils'
import {
  LayoutDashboard,
  Award,
  BookOpen,
  Wrench,
  HelpCircle,
  Shield,
  Sparkles,
  Settings,
  ChevronRight
} from 'lucide-react'

const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
  { name: 'Certification Journey', href: '/certifications', icon: Award },
  { name: 'Enablement', href: '/enablement', icon: BookOpen },
  { name: 'Implementation', href: '/implementation', icon: Wrench },
  { name: 'Support', href: '/support', icon: HelpCircle },
]

export function Sidebar() {
  const { partner } = useAuthStore()
  const location = useLocation()
  
  // Add MSSP section only for MSSP partners
  const navItems = [...navigation]
  if (partner?.type === 'MSSP Partner') {
    navItems.push({ name: 'MSSP', href: '/mssp', icon: Shield })
  }
  
  // Add ASD section for Premium/Elite partners
  if (partner?.tier === 'Premium' || partner?.tier === 'Elite') {
    navItems.push({ name: 'ASD', href: '/asd', icon: Sparkles })
  }
  
  // Add Admin section for admins
  if (partner?.isAdmin) {
    navItems.push({ name: 'Admin', href: '/admin', icon: Settings })
  }

  return (
    <div className="flex w-64 flex-col border-r border-border bg-cloudflare-navy">
      {/* Logo */}
      <div className="flex h-16 items-center border-b border-white/10 px-6">
        <div className="flex items-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded bg-gradient-to-br from-cloudflare-orange to-cloudflare-orange-light">
            <span className="text-lg font-bold text-white">F</span>
          </div>
          <div>
            <h1 className="text-lg font-bold text-white">FlareBase</h1>
            <p className="text-xs text-gray-400">Partner Services Hub</p>
          </div>
        </div>
      </div>
      
      {/* Navigation */}
      <nav className="flex-1 space-y-1 px-3 py-4">
        {navItems.map((item) => {
          const isActive = location.pathname.startsWith(item.href)
          const Icon = item.icon
          
          return (
            <NavLink
              key={item.name}
              to={item.href}
              className={cn(
                'group flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'bg-cloudflare-orange text-white'
                  : 'text-gray-300 hover:bg-white/5 hover:text-white'
              )}
            >
              <Icon className="h-5 w-5" />
              <span className="flex-1">{item.name}</span>
              {isActive && <ChevronRight className="h-4 w-4" />}
            </NavLink>
          )
        })}
      </nav>
      
      {/* Partner info */}
      <div className="border-t border-white/10 p-4">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-cloudflare-orange/20">
            <span className="text-sm font-medium text-cloudflare-orange">
              {partner?.name?.charAt(0).toUpperCase() || '?'}
            </span>
          </div>
          <div className="flex-1 min-w-0">
            <p className="truncate text-sm font-medium text-white">
              {partner?.name || 'Loading...'}
            </p>
            <p className="truncate text-xs text-gray-400">
              {partner?.type} • {partner?.tier}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
